import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Tabs } from "antd";

import ProductTable from "../Tables/ProductTable";
import { InstrumentContext } from "../../providers/InstrumentContextProvider";

export default function ProductsTableTabContent({ currentInstrument, items }) {
    const navigate = useNavigate();
    const { setInstrumentName, instrumentsList } = useContext(InstrumentContext);
    const [tabs, setTabs] = useState(null);
    useEffect(() => {
        if (items) {
            setTabs(
                Object.entries(items)
                    .filter((item) => item[0] !== "indices")
                    .map((item) => ({
                        key: item[0],
                        label: item[1].descripcion,
                        children: (
                            <ProductTable instumentCode={item[0]} instrumentProductPageUrl={item[1].product_url} />
                        ),
                    })),
            );
        }
    }, [items]);

    return (
        tabs && (
            <Tabs
                className="cot-tabs"
                items={tabs}
                defaultActiveKey={currentInstrument.toLowerCase() || 1}
                onChange={(key) => {
                    setInstrumentName(instrumentsList[key.toLowerCase()].descripcion);
                    navigate(`/${key}/`, { replace: true });
                }}
            />
        )
    );
}
